// import of a statemanager store. Adjust to meet component requirements.
import { useMainStore } from "stores/main.store"
import { useFormsStore } from "stores/forms.store"
import FormInputSelect from "components/FormElements/FormInputSelect/FormInputSelect.vue"
import FormInputGeneric from "components/FormElements/FormInputGeneric/FormInputGeneric.vue"
import FormInputTextarea from "components/FormElements/FormInputTextarea/FormInputTextarea.vue"
import FormInputCheckbox from "components/FormElements/FormInputCheckbox/FormInputCheckbox.vue"
import { computed, ref, watch } from "vue"
import nameValidator from "foundation/js/validators/nameValidator"
import emailValidator from "foundation/js/validators/emailValidator"
import nonEmptyStringValidator from "foundation/js/validators/nonEmptyStringValidator"
import phoneValidator from "foundation/js/validators/phoneValidator"

export default {
    name: "FormSalesContactSection",
    components: {
        FormInputSelect,
        FormInputGeneric,
        FormInputTextarea,
        FormInputCheckbox,
    },
    props: {
        labels: {
            type: Object,
            required: true,
        },
        guid: {
            type: String,
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
    },
    setup(props) {

        // enabling store in component
        const mainStore = useMainStore()
        const formsStore = useFormsStore()
        const displayErrors = ref(false)
        const firstName = ref("")
        const lastName = ref("")
        const email = ref("")
        const phone = ref("")
        const companyName = ref("")
        const jobTitle = ref("")
        const message = ref("")
        const consent = ref(false)

        const isSubmitting = computed(() => formsStore.isSubmitting)
        const errorObject = computed(() => formsStore.errors[props.guid])
        const successObject = computed(() => formsStore.success[props.guid])

        watch(errorObject, (newValue) => {
            if (newValue.error) {
                mainStore.changeOverlaySettings({showOverlay: true, overlayType: "prompt", styles: "error", titleText: newValue.title, content: {
                    htmlString: newValue.detail,
                }})
            }
        })

        const isAllFieldsValid = function () {
            const validators = [
                nameValidator(firstName.value),
                nameValidator(lastName.value),
                nameValidator(companyName.value),
                emailValidator(email.value),
                nonEmptyStringValidator(message.value),
                consent.value,
            ]

            return validators.every((validator) => validator)
        }

        const getFormBody = function () {
            return {
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                phone: phone.value,
                companyName: companyName.value,
                jobTitle: jobTitle.value,
                message: message.value,
                consent: consent.value,
            }
        }

        const submitForm = function () {
            displayErrors.value = false

            const isFormValid = isAllFieldsValid()

            setTimeout(() => {
                displayErrors.value = !isFormValid
            }, 10)

            if (!isFormValid) return

            formsStore.submitSaleForm({ guid: props.guid, body: getFormBody() })
            displayErrors.value = false
        }

        return {
            displayErrors,
            firstName,
            lastName,
            email,
            phone,
            companyName,
            jobTitle,
            message,
            consent,
            isSubmitting,
            errorObject,
            successObject,
            nameValidator,
            emailValidator,
            phoneValidator,
            nonEmptyStringValidator,
            submitForm,
        }
    },
}
